export class RoutePaths {
    static IdleScreen = '/';
    static ApplicationSelect = '/applications';
    static LanguageSelect = '/languages';
    static KioskOutOfOrder = '/kioskOutOfOrder';
    static CashAccepterStep = '/CashAccepterStep';
    static CashCollection = '/collection';
    static CashCollectionSummary = '/collectionSummary';
    static CashCollectionSuccess = '/collectionSuccess';

    static AdminHome = '/admin';
    static Registration = '/admin/registration';
}
